import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resource, page, size }) =>
    present(
      repository
        .getResourceSubordinates(resource, page, size)
        .then(({ resources, currentPage }) => ({
          resource,
          team: resources,
          size,
          currentPage,
        }))
        .catch(() => Promise.reject({ resource })),
    );
}

export type { Interactor };

export { createInteractor };
